import { render, staticRenderFns } from "./EditData.vue?vue&type=template&id=24c6ce15&scoped=true&"
import script from "./EditData.vue?vue&type=script&lang=js&"
export * from "./EditData.vue?vue&type=script&lang=js&"
import style0 from "./EditData.vue?vue&type=style&index=0&id=24c6ce15&prod&scoped=true&lang=css&"
import style1 from "./EditData.vue?vue&type=style&index=1&id=24c6ce15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c6ce15",
  null
  
)

export default component.exports